import React, {Component} from 'react';
import {Link} from "react-router-dom";
import Modal from 'react-responsive-modal';
import "./articles.css";
import "../homepage/homePage.css";
import Parser from 'html-react-parser';
import {
  FacebookShareButton,
  GooglePlusShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  PinterestShareButton,
} from 'react-share';
import moment from 'moment';
import ArticleDefaultImage from './img/article_default_image.png';

const format = 'YYYY-MM-DD HH:mm';
const now = moment();

class BlogCard extends Component {
  state={
    open:false,
  }
  ellipsizeTextBox = (id,MAX_LENGTH) =>{

      var el = document.querySelector(id);
      console.log(el);
      if (el){
        var string = el.innerHTML;

        if (string.length > MAX_LENGTH){
          el.innerHTML = Parser(string.substring(0,MAX_LENGTH)+ '...');
        }
      }
  }
  onOpenModal = () => {
      this.setState({ open: true });
    };

    onCloseModal = () => {
      this.setState({ open: false });
    };
    componentDidMount(){
      if (this.props.mode===2){ console.log("#desc"+this.props.mode+"_"+this.props.blog.id+" Mode:"+this.props.mode+", MAX_LENGTH:80");this.ellipsizeTextBox("#desc"+this.props.mode+"_"+this.props.blog.id,80);}
      else {
        console.log("#desc"+this.props.mode+"_"+this.props.blog.id+" Mode:"+this.props.mode+", MAX_LENGTH:210");
      this.ellipsizeTextBox("#desc"+this.props.mode+"_"+this.props.blog.id,210);
    }

    }
    constructor(props){
      super(props);
    }
    render() {
      const hasImage = this.props.blog.image && this.props.blog.image !== '' ? true : false
    	return (
        <div>
        <Modal open={this.state.open} onClose={this.onCloseModal}>
          <div className="BlogDetailCard">
            <h2 class='BlogTitle'>
              {this.props.blog.title}
            </h2>
            <p class='BlogDate'>
              {moment(this.props.blog.date).format("dddd Do, MMM YYYY")}
            </p>
            {
              hasImage ? (
                <img class='BlogImage' src={this.props.blog.image}/>
              ) : null
            }
            <p className="BlogText" dangerouslySetInnerHTML={{__html: this.props.blog.htmlcontent}} >
            </p>
          </div>
        </Modal>
        {
          this.props.onlyTitle?
          <div className="node" onClick={this.onOpenModal}>{this.props.blog.title}</div>
          :
        <div className={this.props.mode!==1?"BlogCard":"BlogCardFlex"}>


          <div className={this.props.mode!==2?"ImageCol":"ImageRow"} onClick={this.onOpenModal}>
            <img src={hasImage ? this.props.blog.image : ArticleDefaultImage} alt=""/>
          </div>


          <div className="BlogCol">
            {this.props.mode!==2?
              <div>
            <div className="monza-entry-cat">
            {
              Array.isArray(this.props.blog.groups) && this.props.blog.groups.map((group,i)=>{
                return(
                  <Link key={i} to="/search/label/${group}">{group}</Link>
                )
              })
            }
            </div>
            <h2 className="post-title entry-title BlogTitle" itemProp="headline">
              {this.props.blog.title}
            </h2>
            <div className="postmeta-primary">
            <span className="entry-postmeta-author post-author vcard BlogUser BlogDate"><i className="fa fa-user"></i>&nbsp;<span className="fn" itemProp="author">{this.props.blog.creator && this.props.blog.creator.name}</span></span>
            <span className="entry-postmeta-date BlogDate"><i className="fas fa-calendar"></i>&nbsp;{moment(this.props.blog.date).format("dddd Do, MMM YYYY")}</span>&nbsp;&nbsp;
            </div>
            </div>

            :""}
            <div id={"desc"+this.props.mode+"_"+this.props.blog.id} className="BlogDesc" onClick={this.props.mode===2?this.onOpenModal:undefined}>{`${this.props.blog.desc.replace(/<(?:.|\n)*?>/gm, '').substring(0,30)}...`}</div>
            {this.props.mode!==2?
            <div className="pbt-share-buttons w-100 text-center d-flex">Share&#58;<FacebookShareButton
                url={String(window.location)}
                quote={this.props.blog.title}
                className="FBShareButton">
                <i className="fa fa-facebook" style={{background:"#3b5998"}}></i>
              </FacebookShareButton>
              <TwitterShareButton
                url={String(window.location)}
                title={this.props.blog.title}
                className="TWShareButton">
                <i className="fa fa-twitter" style={{background:"#1da1f2"}}></i>
              </TwitterShareButton>
              <GooglePlusShareButton
                          url={String(window.location)}
                          className="GPShareButton">
                          <i className="fa fa-google-plus" style={{background:"#dd4b39"}}></i>
                        </GooglePlusShareButton>
              <PinterestShareButton
                url={String(window.location)}
                media={this.props.blog.image}
                windowWidth={1000}
                windowHeight={730}
                className="PIShareButton">
                <i className="fa fa-pinterest" style={{background:"#bd081c"}}></i>
              </PinterestShareButton>
              <LinkedinShareButton
                url={String(window.location)}
                title={this.props.blog.title}
                windowWidth={750}
                windowHeight={600}
                className="LIShareButton">
                <i className="fa fa-linkedin" style={{background:"#0077b5"}}></i>
              </LinkedinShareButton>


            </div>:""}
            {this.props.mode!==2?
            <div id="readmore" className="monza-entry-more BlogReadMore" onClick={this.onOpenModal} >
              <p>Read More</p>
            </div>
            :""}
          </div>

	      </div>
      }
      </div>
	    );
    }
}

export default BlogCard;
